var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.002 51C102.002 62.5432 98.1468 73.2469 91.6872 81.8519C88.1448 86.4691 83.8731 90.5617 78.9762 93.7099C71.058 98.9568 61.5769 102 51.3665 102C23.3399 102 0.626953 79.1235 0.626953 51C0.626953 22.7716 23.3399 0 51.2623 0C61.4727 0 70.9538 3.04321 78.872 8.18519C83.7689 11.3333 88.0406 15.4259 91.583 20.0432C98.1468 28.7531 102.002 39.3519 102.002 51Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77315 17.9449C2.71084 17.9449 3.54434 17.2103 3.54434 16.1609C3.54434 15.2165 2.81503 14.377 1.77315 14.377C0.835456 14.377 0.00195312 15.1115 0.00195312 16.1609C0.00195312 17.2103 0.731268 17.9449 1.77315 17.9449Z",
    fill: "url(#paint0_linear_273_12606)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87666 97.5933C2.81435 97.5933 3.64786 96.8587 3.64786 95.8093C3.64786 94.76 2.91854 94.0254 1.87666 94.0254C0.938972 94.0254 0.105469 94.76 0.105469 95.8093C0.105469 96.8587 0.938972 97.5933 1.87666 97.5933Z",
    fill: "url(#paint1_linear_273_12606)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9229 15.1041C97.8606 15.1041 98.5899 14.3695 98.5899 13.4251C98.5899 12.4807 97.8606 11.7461 96.9229 11.7461C95.9852 11.7461 95.2559 12.4807 95.2559 13.4251C95.2559 14.3695 95.9852 15.1041 96.9229 15.1041Z",
    fill: "url(#paint2_linear_273_12606)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_273_12606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9173 24.9013C44.2645 25.201 42.7619 25.6504 41.2594 26.2498C32.2446 29.8464 25.934 37.9386 24.4315 47.2296C23.8305 50.5264 23.9809 53.8232 24.5819 57.2699C27.5868 71.9557 42.1608 81.5466 56.885 78.3997C71.6092 75.2527 81.2252 60.8666 78.07 46.1807C77.0182 40.9358 74.464 36.1405 70.5576 32.3941C64.3975 25.8004 54.9321 22.9532 45.9173 24.9013Z",
    fill: "url(#paint3_linear_273_12606)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0409 41.6323C53.6374 41.5688 55.6091 43.5596 55.7032 45.9283C55.7249 46.4753 55.2995 46.9364 54.753 46.9581C54.2066 46.9799 53.7459 46.554 53.7242 46.007C53.6724 44.7041 52.5876 43.5776 51.0893 43.6143C50.7704 43.6221 50.3339 43.7369 49.0914 44.0877C46.3398 44.8646 44.3865 46.0518 43.9104 48.4814C43.8249 48.9177 43.8205 49.4246 43.8205 50.7135V52.3735C43.8205 53.6623 43.8249 54.1694 43.9104 54.6056C44.3865 57.0352 46.3398 58.2224 49.0914 58.9993C50.3339 59.3501 50.7704 59.4649 51.0893 59.4727C52.5876 59.5094 53.6724 58.3828 53.7242 57.08C53.7459 56.5329 54.2066 56.1071 54.753 56.1289C55.2995 56.1506 55.7249 56.6116 55.7032 57.1587C55.6091 59.5273 53.6374 61.5183 51.0409 61.4547C50.4373 61.4399 49.7364 61.2417 48.7101 60.9516C48.6588 60.9371 48.6067 60.9223 48.5537 60.9074C45.6378 60.0841 42.6712 58.5821 41.9669 54.9872C41.8396 54.3378 41.8397 53.6247 41.8399 52.4889C41.8399 52.4509 41.8399 52.4124 41.8399 52.3735V50.7135C41.8399 50.6746 41.8399 50.6361 41.8399 50.5981C41.8397 49.4624 41.8396 48.7493 41.9669 48.0999C42.6712 44.5049 45.6378 43.0029 48.5537 42.1796C48.6067 42.1647 48.6588 42.1499 48.7101 42.1354C49.7365 41.8453 50.4373 41.6471 51.0409 41.6323Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2657 52.541C48.7188 52.541 48.2754 52.0971 48.2754 51.5497C48.2754 51.0022 48.7188 50.5585 49.2657 50.5585H56.693V49.9693C56.6928 49.7953 56.6927 49.5815 56.7145 49.4066L56.7149 49.4033C56.7305 49.2779 56.8017 48.7069 57.3618 48.435C57.9231 48.1624 58.4184 48.4617 58.5255 48.5264L58.9895 48.8626C59.3616 49.1547 59.8711 49.5568 60.2583 49.934C60.4515 50.1221 60.6509 50.3375 60.8081 50.5664C60.948 50.7698 61.1493 51.1169 61.1493 51.5439C61.1493 51.9708 60.948 52.3179 60.8081 52.5214C60.6509 52.7502 60.4515 52.9656 60.2583 53.1538C59.8711 53.531 59.3617 53.933 58.9895 54.2251L58.5255 54.5613C58.4184 54.626 57.9231 54.9254 57.3618 54.6528C56.8017 54.3809 56.7305 53.8098 56.7149 53.6845L56.7145 53.6811C56.6927 53.5063 56.6928 53.2925 56.693 53.1184V52.541H49.2657Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_273_12606",
    x: 14.2088,
    y: 20.6088,
    width: 74.3012,
    height: 74.3793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.15002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92002
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_12606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_12606",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_273_12606",
    x1: 0.00195312,
    y1: 16.2429,
    x2: 3.36993,
    y2: 16.2429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_273_12606",
    x1: 0.177775,
    y1: 95.8704,
    x2: 3.54575,
    y2: 95.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_273_12606",
    x1: 95.2965,
    y1: 13.4426,
    x2: 98.4596,
    y2: 13.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_273_12606",
    x1: 34.1744,
    y1: 29.9762,
    x2: 72.4647,
    y2: 71.2893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg43);
export default __webpack_public_path__ + "static/media/43.903fdb8107dc1f9e7d220f7d9035c479.svg";
export { ForwardRef as ReactComponent };